module.exports = __webpack_public_path__ + "static/media/윤영채.02120643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/윤영채.jpg
// module id = 107
// module chunks = 0